'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TimeWindowsIterator = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _WeeklyTimeWindowsIterator = require('./WeeklyTimeWindowsIterator');

var _DateTimeWindowsIterator = require('./DateTimeWindowsIterator');

var _Status = require('./Status');

var Status = _interopRequireWildcard(_Status);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TimeWindowsIterator = exports.TimeWindowsIterator = function () {
    /**
     * @param availability   availability.Availability
     * @param cal            Moment with tz
     */
    function TimeWindowsIterator(_ref) {
        var _ref$availability = _ref.availability,
            availability = _ref$availability === undefined ? {} : _ref$availability,
            cal = _ref.cal;

        _classCallCheck(this, TimeWindowsIterator);

        this._regularIt = new _WeeklyTimeWindowsIterator.WeeklyTimeWindowsIterator({
            cal: cal,
            weekly: availability.weekly
        });
        this._exceptionsIt = new _DateTimeWindowsIterator.DateTimeWindowsIterator({
            cal: cal,
            timeWindows: availability.exceptions
        });

        // TimeWindow iterators always return at least one element
        this._regularStatus = this._regularIt.next();
        this._exceptionStatus = this._exceptionsIt.next();
        this._hasNext = true;
    }

    /** @return Boolean */


    _createClass(TimeWindowsIterator, [{
        key: 'hasNext',
        value: function hasNext() {
            return this._hasNext;
        }

        /** @return Status */

    }, {
        key: 'next',
        value: function next() {
            // Future has no exceptions?
            if (this._exceptionStatus.status === Status.STATUS_UNKNOWN && !this._exceptionStatus.until) {
                // Continue with regular statuses
                var lastRegularStatus = this._regularStatus;
                if (this._regularIt.hasNext()) {
                    this._regularStatus = this._regularIt.next();
                } else {
                    this._hasNext = false;
                }
                return lastRegularStatus;
            }

            // So we do have real exceptions to deal with

            // Real exceptions take precedent
            if (Status.STATUS_UNKNOWN !== this._exceptionStatus.status) {
                // If the exception is indefinite, it trumps everything else
                if (!this._exceptionStatus.until) {
                    this._hasNext = false;
                    return this._exceptionStatus;
                }

                var lastExceptionStatus = this._exceptionStatus;
                this._exceptionStatus = this._exceptionsIt.next(); // we know there are still real exceptions later

                while (this._regularStatus.until && this._regularStatus.until <= lastExceptionStatus.until) {
                    this._regularStatus = this._regularIt.next();
                }

                return lastExceptionStatus;
            }

            // No real exception this time
            if (!this._regularStatus.until || this._regularStatus.until > this._exceptionStatus.until) {
                var _lastExceptionStatus = this._exceptionStatus;
                this._exceptionStatus = this._exceptionsIt.next(); // we know there are still real exceptions later
                return {
                    status: this._regularStatus.status,
                    until: _lastExceptionStatus.until
                };
            } else if (this._regularStatus.until < this._exceptionStatus.until) {
                var _lastRegularStatus = this._regularStatus;
                this._regularStatus = this._regularIt.next(); // we know there are still regular statuses later
                return _lastRegularStatus;
            } else {
                this._exceptionStatus = this._exceptionsIt.next(); // we know there are still real exceptions later
                var _lastRegularStatus2 = this._regularStatus;
                this._regularStatus = this._regularIt.next(); // we know there are still regular statuses later
                return _lastRegularStatus2;
            }
        }
    }]);

    return TimeWindowsIterator;
}();